import React, { useRef, useState, useEffect, useCallback } from 'react';
import './MobileScrollTable.css';

interface MobileScrollTableProps {
  children: React.ReactNode;
  showHint?: boolean;
}

const MobileScrollTable: React.FC<MobileScrollTableProps> = ({ children, showHint = true }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  const checkOverflow = useCallback(() => {
    const el = containerRef.current;
    if (el) {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [checkOverflow]);

  // Re-check after children render
  useEffect(() => {
    const timeout = setTimeout(checkOverflow, 100);
    return () => clearTimeout(timeout);
  }, [children, checkOverflow]);

  const handleScroll = () => {
    if (!hasScrolled) {
      setHasScrolled(true);
      try { sessionStorage.setItem('mst_scrolled', '1'); } catch { /* noop */ }
    }
  };

  // Check if already scrolled in this session
  useEffect(() => {
    try {
      if (sessionStorage.getItem('mst_scrolled') === '1') {
        setHasScrolled(true);
      }
    } catch { /* noop */ }
  }, []);

  return (
    <div className="mobile-scroll-table-wrapper">
      {showHint && isOverflowing && !hasScrolled && (
        <div className="mobile-scroll-hint">
          <span>&larr; Scroll to see more &rarr;</span>
        </div>
      )}
      <div
        ref={containerRef}
        className="mobile-scroll-table-container"
        onScroll={handleScroll}
      >
        {children}
      </div>
    </div>
  );
};

export default MobileScrollTable;
